/**
 * Find project name from a projects array by project ID.
 *
 * @param {Array} projects - Array of project objects
 * @param {string} projectId - The project ID to look up
 * @returns {string} Project name or "-" if not found
 */
export function getProjectName(projects, projectId) {
  if (!projectId) return "-";
  const project = projects.find((p) => p.id === projectId);
  return project ? (project.division ? `${project.name} (${project.division})` : project.name) : "-";
}
